import { CodeFieldIncludeInactiveKey } from 'app/area/codetable/types-store';

export const defaultMaxResults = 50;
export const defaultIncludeInactiveCodes = CodeFieldIncludeInactiveKey.active;
